
import { useState } from 'react';

export default function InsuranceDetailsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            年次点検で自動付帯される損害賠償保険
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            年次点検を受けていただくことで、業務中の万が一の事故に備えた損害賠償保険が自動的に付帯されます。2年目以降も更新手続きは不要で、毎年の点検で保険が継続されます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">基本補償（身体障害・財物損壊）</h3>
            </div>
            <div className="space-y-4 mb-6">
              <div className="flex items-center justify-between p-4 bg-white rounded-lg">
                <span className="text-gray-700 font-medium">対人補償</span>
                <span className="text-2xl font-bold text-blue-600">最大1億円</span>
              </div>
              <div className="flex items-center justify-between p-4 bg-white rounded-lg">
                <span className="text-gray-700 font-medium">対物補償</span>
                <span className="text-2xl font-bold text-blue-600">最大5,000万円</span>
              </div>
            </div>
            <p className="text-gray-600 leading-relaxed">
              被保険者が所有・使用・管理している業務用ドローンの管理不備、または被保険者や従業員等のドローン使用業務中のミスにより発生した偶然の事故で、他人の生命・身体を害したり、他人の財物を損壊（滅失、破損、汚損）した場合に、法律上の損害賠償責任を負担する損害賠償金や訴訟費用等を補償します。
            </p>
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl border border-green-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">管理財物損壊補償</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                業務遂行にあたり、一時的に使用または管理する他人の財物の損壊により、法律上の賠償責任を負担する場合、その修理費用を補償します。
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-2xl border border-purple-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-group-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">追加補償者特約</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                ドローンを他者に貸与した場合、貸与を受けた方も被保険者として補償対象になります（日本国内の事業に限る）。共同利用でも安心です。
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-6 text-center">保険の特徴</h3>
          <div className="grid md:grid-cols-5 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-gift-line text-3xl"></i>
              </div>
              <p className="font-medium">購入時も1年間無償付帯（登録不要）</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-refresh-line text-3xl"></i>
              </div>
              <p className="font-medium">年次点検で毎年自動更新</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-file-text-line text-3xl"></i>
              </div>
              <p className="font-medium">点検証明書と被保険者証を発行</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-checkbox-circle-line text-3xl"></i>
              </div>
              <p className="font-medium">更新手続き不要</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-user-line text-3xl"></i>
              </div>
              <p className="font-medium">追加補償者特約で共同利用も安心</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
